import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const Tiles = styled.div `
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${THEME.GRID_SPACING}px;
  height: 100%;
`;
const TileBox = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border: 1px solid ${THEME.BORDER};
  border-radius: 6px;
  padding: 12px 8px;
  text-align: center;
`;
const TileLabel = styled.div `
  color: ${THEME.COLOR_GREY};
  font-size: 0.85em;
`;
const TileValue = styled.div `
  color: ${THEME.COLOR_PRIMARY};
  font-size: 1.6em;
  font-weight: 700;
`;
const TileFootnote = styled.div `
  color: ${(p) => p.$color};
  font-size: 0.75em;
`;
const StatTiles = ({ tiles }) => (React.createElement(Tiles, null, tiles.map((tile) => (React.createElement(TileBox, { key: tile.label },
    React.createElement(TileLabel, null, tile.label),
    React.createElement(TileValue, null, tile.value),
    tile.footnotes?.map((footnote) => (React.createElement(TileFootnote, { key: footnote.text, $color: footnote.color, title: footnote.title }, footnote.text))))))));
export default StatTiles;
//# sourceMappingURL=StatTiles.js.map